export default __webpack_public_path__ + "static/media/concreterose.22ca5a50.svg";